import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';

export default class AdvancedControlsComponent extends Component {
  @service stereo;

  // Chromecast reports a device name, AirPlay does not.
  get targetLabel() {
    return (
      this.stereo.castDeviceName ??
      (this.stereo.castIconName === 'cast' ? 'Cast' : 'AirPlay')
    );
  }

  // The archive cast URL is token-signed and fetched on demand, and the picker click can't wait on it.
  applyRemoteUrlTask = task({ restartable: true }, async () => {
    let feed = this.args.feed;
    if (!feed?.canRemotePlay) return;

    let url = feed.remotePlaybackUrl ?? (await feed.fetchRemotePlaybackUrl());
    if (!url || this.args.feed !== feed) return;

    let sound = feed.loadedSound;
    if (sound) {
      sound.castUrl = url;
    }
  });

  @action
  applyRemoteUrl() {
    this.applyRemoteUrlTask.perform().catch(() => {});
  }
}
